module.exports = __webpack_public_path__ + "static/media/selfie-face-no-light.dd77bc57.svg";